import { Component, input, numberAttribute } from '@angular/core';
import { LucideDynamicIcon, type LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'app-admin-icon',
  standalone: true,
  imports: [LucideDynamicIcon],
  template: `<svg lucideIcon [lucideIcon]="name()" [size]="size()" [strokeWidth]="strokeWidth()" />`,
})
export class AdminIconComponent {
  readonly name = input.required<LucideIconInput>();
  readonly size = input(20, { transform: numberAttribute });
  readonly strokeWidth = input(1.75, { transform: numberAttribute });
}
